export default {
  namespaced: true,
  unsubscribe: null,
  state () {
    return {
      data: [],
      kanpoList: [],
      checkedKanpoList: [],
      herbList: [],
      checkedHerbList: [],
      weightInptedList: {},
      isCheckedKanpoApplied: false,
      isCheckedHerbApplied: false,
      isNonZeroHerbApplied: false,
    }
  },
  mutations: {
    setKanpoList(state, val) {
      state.kanpoList = val
    },
    updateKanpoList(state, e) {
      const ckl = state.checkedKanpoList
      if (ckl.includes(e.target.name)) {
        state.checkedKanpoList = ckl.filter(l => l != e.target.name)
      } else {
        ckl.push(e.target.name)
        state.checkedKanpoList = ckl
      }
    },
    toggleIsCheckedKanpoApplied(state) {
      state.isCheckedKanpoApplied = !state.isCheckedKanpoApplied
    },
    setHerbList(state, val) {
      state.herbList = val
    },
    updateHerbList(state, e) {
      if (state.checkedHerbList.includes(e.target.name)) {
        state.checkedHerbList = state.checkedHerbList.filter(l => l != e.target.name)
      } else {
        const hl = state.checkedHerbList
        hl.push(e.target.name)
        state.checkedHerbList = hl
      }
    },
    toggleIsCheckedHerbApplied(state) {
      state.isCheckedHerbApplied = !state.isCheckedHerbApplied
    },
    setWeightInptedList(state, payload) {
      const obj = {}
      const value = payload.event.target.value
      obj[payload.makerNum] = value === '' ? null : value
      state.weightInptedList = Object.assign({}, state.weightInptedList, obj)
    },
    toggleIsNonZeroHerbApplied(state) {
      state.isNonZeroHerbApplied = !state.isNonZeroHerbApplied
    },
    clearCheckedKanpoList(state) {
      state.checkedKanpoList = []
      state.isCheckedKanpoApplied = false
    },
    clearWeightInptedList(state) {
      state.weightInptedList = []
      state.isNonZeroHerbApplied = false
    },
    clearCheckedHerbList(state) {
      state.checkedHerbList = []
      state.isCheckedHerbApplied = false
    },
  },
  getters: {
    pureHerbList(state) {
      return state.herbList.filter(herb => !['Maker', 'No'].includes(herb))
    },
    visibleHerbList(state, getters) {
      const nonZeroHerbList = Object.keys(getters.herbWeightList).filter(h => getters.herbWeightList[h] !== 0)

      if (state.isNonZeroHerbApplied) {
        return getters.pureHerbList.filter(herb => nonZeroHerbList.includes(herb))
      } else {
        return getters.pureHerbList
      }
    },
    herbWeightList(state, getters) {
      const returnObj = {}
      getters.pureHerbList.forEach(herb => returnObj[herb] = 0)

      Object.keys(state.weightInptedList).forEach(makerNum => {
        let kanpo = state.kanpoList.find((kanpo) => {
          return `${kanpo.Maker}-${kanpo.No}` === makerNum
        })
        if (typeof kanpo === 'undefined') return
        kanpo = Object.assign({}, kanpo)
        delete kanpo.id
        delete kanpo.Maker
        delete kanpo.No
        delete kanpo.name

        const totalWeight = Object.values(kanpo).map(w => parseFloat(w)).reduce((p, w) => p + w, 0)

        Object.keys(kanpo).forEach(herb => {
          const makerNumWeightInputed = parseFloat(state.weightInptedList[makerNum])
          if (makerNumWeightInputed === null || isNaN(makerNumWeightInputed)) {
            returnObj[herb] = 0
          } else {
            returnObj[herb] = returnObj[herb] + parseFloat(kanpo[herb]) * makerNumWeightInputed / totalWeight
          }
        })
      })
      return returnObj
    },
  },
  actions: {
  }
}
